import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '../../../utils';
import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';

@Pipe({
  name: 'cxnestedread',
})
export class CxNestedRead implements PipeTransform {
  transform(object: any, column: any): string {
    if (column.isArray) {
      if (Array.isArray(object[column.key])) {
        return object[column.key].map((x: any) => x.name).join(', ');
      }
    }

    if (column.format === 'date' || column.type === 'date') {
      const val = object[column.key];
      return moment(val).format('DD MMM YYYY');
    }
    if (column.format === 'time') {
      const val = Number(object[column.key]);
      return formatDate(val);
    }
    if (column.format === 'datetime') {
      const val = (column.key.indexOf('.') > -1) ? this.getNestedProperty(object, column.key) : object[column.key];
    
      if (
        val === undefined ||
        val === null ||
        val === '' ||
        Number.isNaN(val)
      ) {
          return 'N/A';
      }

      const date = moment(val);
      return date.isValid() ? date.format('DD MMM YYYY hh:mm a') : 'N/A';
    }
    if (column.key.indexOf('.') > -1) {
      return this.checkProperty(object, column.key);
    } else {
      if (
        (object[column.key] === undefined ||
          object[column.key] === null ||
          object[column.key] === '' ||
          Number.isNaN(object[column.key])) &&
        column.key !== 'action'
      ) {
        return 'NA';
      }
    }
    // if (!object[column.key]) {
    //   return 'NA';
    // }

    return this.byString(object, column.key);
  }

  getNestedProperty(obj: any, propertyPath: any) {
    return propertyPath.split('.').reduce((acc: any, part: any) => acc && acc[part], obj);
  }

  checkProperty(obj: any, propertyPath: any) {
    if (!this.getNestedProperty(obj, propertyPath)) {
      return 'N/A';
    }
    return this.getNestedProperty(obj, propertyPath);
  }

  byString(o: any, s: any) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, ''); // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  }

}
